import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { getPaymentCollectionsAdvancedApiBaseUrl } from '@core/reconciliation-api-url';
import { FinancialDeliveryGenerationResponse, FinancialDeliveryOccurrence, FinancialSourceSchedule, GenerateFinancialDeliveriesRequest, UpsertFinancialSourceScheduleRequest } from '../models/bank-schedule.model';

@Injectable({ providedIn: 'root' })
export class BankScheduleApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${getPaymentCollectionsAdvancedApiBaseUrl()}/api/financial-operations`;

  getAll(sourceId?: string): Observable<FinancialSourceSchedule[]> {
    const params = sourceId ? new HttpParams().set('sourceId', sourceId) : undefined;
    return this.http.get<FinancialSourceSchedule[]>(`${this.baseUrl}/source-schedules`, { params });
  }

  save(request: UpsertFinancialSourceScheduleRequest): Observable<FinancialSourceSchedule> {
    return this.http.post<FinancialSourceSchedule>(`${this.baseUrl}/source-schedules`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/source-schedules/${id}`);
  }

  getDeliveries(fromDate: string, toDate: string, sourceId?: string): Observable<FinancialDeliveryOccurrence[]> {
    let params = new HttpParams().set('fromDate', fromDate).set('toDate', toDate);
    if (sourceId) params = params.set('sourceId', sourceId);
    return this.http.get<FinancialDeliveryOccurrence[]>(`${this.baseUrl}/deliveries`, { params });
  }

  generateDeliveries(request: GenerateFinancialDeliveriesRequest): Observable<FinancialDeliveryGenerationResponse> {
    return this.http.post<FinancialDeliveryGenerationResponse>(`${this.baseUrl}/deliveries`, request);
  }
}
